/* tslint:disable */
/* eslint-disable */
/**
 * SI Implicit-Bias API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImplicitBiasInput
 */
export interface ImplicitBiasInput {
    /**
     * 
     * @type {number}
     * @memberof ImplicitBiasInput
     */
    responseTimeMilliseconds: number;
    /**
     * 
     * @type {number}
     * @memberof ImplicitBiasInput
     */
    blockID: number;
    /**
     * 
     * @type {number}
     * @memberof ImplicitBiasInput
     */
    trialID: number;
    /**
     * 
     * @type {boolean}
     * @memberof ImplicitBiasInput
     */
    correct: boolean;
}

export function ImplicitBiasInputFromJSON(json: any): ImplicitBiasInput {
    return ImplicitBiasInputFromJSONTyped(json, false);
}

export function ImplicitBiasInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImplicitBiasInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'responseTimeMilliseconds': json['responseTimeMilliseconds'],
        'blockID': json['blockID'],
        'trialID': json['trialID'],
        'correct': json['correct'],
    };
}

export function ImplicitBiasInputToJSON(value?: ImplicitBiasInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'responseTimeMilliseconds': value.responseTimeMilliseconds,
        'blockID': value.blockID,
        'trialID': value.trialID,
        'correct': value.correct,
    };
}


